<!--

AvatarImage component shows only user avatar image or user initials if avatar image is not set.
Unlike Avatar component, AvatarImage displays ONLY the standard rounded image/initial with optional availability indicator.
Also, availability is determined from provided data, Avatar.vue is using availability of the currently logged-in user

@param name - name to extract initials from
@param image - URI to the avatar image
@param available - availability status to display
---
@param size - size option, see SBAvatarImageSize in src/helpers/lists/avatarSize.js
@param showAvailability - boolean, if true displays a green/red availability indicator
-->

<template>
  <div
    class="avatar"
    :class="size"
    :style="image ? `background-image: url(${image}); background-color: unset !important;` : ''">
    <template v-if="!image">{{ name | initials(1) }}</template>
    <span
      v-if="showAvailabilityStatus"
      class="indicator"
      :class="[available ? 'green' : 'red']"/>
  </div>
</template>

<script>
import SBAvatarImageSize from '../../helpers/lists/avatarSize';

export default {
  name: 'SBAvatarImage',
  components: {},
  mixins: [],
  props: {
    name: {
      type: String,
      required: false,
      default: '',
    },
    image: {
      type: String,
      required: false,
      default: '',
    },
    available: {
      type: Boolean,
      required: false,
      default: false,
    },
    showAvailabilityStatus: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: SBAvatarImageSize.W20,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>

.avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  background: $greyPrimary no-repeat 50% 50%;
  background-size: cover;
  color: $white;
  border-radius: 50%;
  vertical-align: middle;
  text-transform: uppercase;
  text-align: center;

  position: relative;
  height: 26px;
  width: 26px;
  font-size: 12px;
  font-weight: 600;

  .indicator {
    display: inline-block;
    position: absolute;
    bottom: -2px;
    right: -2px;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    border: white 2px solid;

    &.red {
      background-color: $redPrimary;
    }
    &.green {
      background-color: $greenPrimary;
    }
  }

  // sizing
  &.w16 {
    height: 16px;
    width: 16px;
    font-size: 9px;
    line-height: 16px;

    .indicator {
      height: 8px;
      width: 8px;
      bottom: -1px;
      right: -1px;
      border-width: 1px;
    }
  }

  &.w18 {
    height: 18px;
    width: 18px;
    font-size: 11px;
    line-height: 18px;

    .indicator {
      height: 10px;
      width: 10px;
    }
  }

  &.w20 {
    height: 20px;
    width: 20px;
    font-size: 11px;
    line-height: 20px;

    .indicator {
      height: 10px;
      width: 10px;
    }
  }

  &.w30 {
    height: 30px;
    width: 30px;
    font-size: 15px;
    line-height: 20px;

    .indicator {
      height: 10px;
      width: 10px;
    }
  }

  &.w68 {
    height: 68px;
    width: 68px;
    font-size: 35px;
    line-height: 20px;

    .indicator {
      height: 10px;
      width: 10px;
    }
  }
}

</style>
